module.exports = __webpack_public_path__ + "static/Canela-Light-7dc106a4dbb777d90200430ac895f0f0.otf";